import { FuelIllustration } from '@frete.com/fuel-react';
import styled, { css } from 'styled-components';

export const StyledIllustration = styled(FuelIllustration)<{ spacingBottom?: number; spacingTop?: number }>`
  ${({ spacingBottom, spacingTop }) => css`
    ${spacingBottom && ` margin-bottom: ${spacingBottom}px;`}
    ${spacingTop && `margin-top: ${spacingTop}px;`}
  `}
`;
